/**
 * Aumentar contraste (GitHub "Increase contrast"), client-side.
 *
 * Aditivo e sem backend: a preferencia mora no localStorage do dispositivo
 * (igual ao comportamento por-aparelho do GitHub) e e aplicada via o atributo
 * `data-contrast="more"` no <html>. As variantes de alto contraste vivem em
 * design-system/tokens/themes/contrast.css e so re-ancoram os tokens-core; o
 * resto da paleta deriva via color-mix e cascateia sozinho.
 */
export type ContrastMode = 'off' | 'more';

export const CONTRAST_STORAGE_KEY = '7barber-contrast';

export function prefersMoreContrast(): boolean {
  if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
  return window.matchMedia('(prefers-contrast: more)').matches;
}

export function getStoredContrast(): ContrastMode {
  if (typeof window === 'undefined') return 'off';
  try {
    const raw = window.localStorage.getItem(CONTRAST_STORAGE_KEY);
    if (raw === 'more' || raw === 'off') return raw;
  } catch {
    // localStorage indisponivel (modo privado/SSR) - cai no default do sistema.
  }
  return prefersMoreContrast() ? 'more' : 'off';
}

export function applyContrast(mode: ContrastMode): void {
  if (typeof document === 'undefined') return;
  if (mode === 'more') {
    document.documentElement.dataset.contrast = 'more';
  } else {
    delete document.documentElement.dataset.contrast;
  }
}

export function persistContrast(mode: ContrastMode): void {
  try {
    window.localStorage.setItem(CONTRAST_STORAGE_KEY, mode);
  } catch {
    // sem persistencia possivel - aplica so na sessao atual.
  }
}

export function setContrast(mode: ContrastMode): void {
  applyContrast(mode);
  persistContrast(mode);
}
